import { getCompatibleVersions, rest } from 'utils';

export default {
  cluster: {
    create: ({ properties }) => rest.post({ url: 'k8s', body: { properties } }),
    get: ({ id }) => rest.get({ url: `k8s/${id}?depth=2` }),
    getAll: () => rest.get({ url: 'k8s?depth=2' }),
    update: ({ id, properties }) => rest.put({ url: `k8s/${id}`, body: { properties } }),
    delete: ({ id }) => rest.delete({ url: `k8s/${id}` }),
    getKubeConfigFile: ({ id }) => rest.request({ url: `k8s/${id}/kubeconfig`, responseType: 'text' }),
  },

  nodepool: {
    create: ({ clusterId, properties }) => rest.post({
      url: `k8s/${clusterId}/nodepools`,
      body: { properties },
    }),
    get: ({ clusterId, id }) => rest.get({ url: `k8s/${clusterId}/nodepools/${id}` }),
    getAll: ({ clusterId }) => rest.get({ url: `k8s/${clusterId}/nodepools` }),
    update: ({ clusterId, id, properties }) => rest.put({
      url: `k8s/${clusterId}/nodepools/${id}`,
      body: { properties },
    }),
    delete: ({ clusterId, id }) => rest.delete({ url: `k8s/${clusterId}/nodepools/${id}` }),
  },

  node: {
    get: ({ clusterId, nodepoolId, id }) => rest.get({ url: `k8s/${clusterId}/nodepools/${nodepoolId}/nodes/${id}` }),
    getAll: ({ clusterId, nodepoolId }) => rest.get({ url: `k8s/${clusterId}/nodepools/${nodepoolId}/nodes?depth=2` }),
    delete: ({ clusterId, nodepoolId, id }) => rest.delete({ url: `k8s/${clusterId}/nodepools/${nodepoolId}/nodes/${id}` }),
    recreate: ({ clusterId, nodepoolId, id }) => (
      rest.request({
        url: `k8s/${clusterId}/nodepools/${nodepoolId}/nodes/${id}/replace`,
        method: 'POST',
        responseType: 'text',
      })
    ),
  },

  version: {
    getAll: () => rest.get({ url: 'k8s/versions' }),
    getDefault: () => rest.request({ url: 'k8s/versions/default', responseType: 'text' }),
    getCompatibilities: ({ clusterVersion }) => rest.get({ url: 'k8s/versions' })
      .then((versions) => getCompatibleVersions({ versions, currentVersion: clusterVersion })),
  },
};
